(function (Legacy, $) {
  var treeItems = function ($, $field, $flyout) {
    var self = this;
    var $input = $('.dropdowntree-realinput', $field);
    var $tree = $(null);
    var $currentItem;
    var changeSuppressed = false;

    /* initialization */
    $input.change(function () {
      if (changeSuppressed) return;
      self.currentItem(self.getItemByValue($input.val()));
    });

    /* eventing */
    var eventHandlers = {};
    self.on = function (eventName, handler) {
      var existingHandlers;
      if (eventHandlers.hasOwnProperty(eventName))
        existingHandlers = eventHandlers[eventName];
      else {
        existingHandlers = [];
        eventHandlers[eventName] = existingHandlers;
      }

      existingHandlers.push(handler);
    };
    var raise = function (eventName, data) {
      var handlers;
      if (eventHandlers.hasOwnProperty(eventName))
        handlers = eventHandlers[eventName];

      if (handlers) {
        for (var i = 0; i < handlers.length; i++) {
          handlers[i].call(self, data);
        }
      }
    };

    /* item accessors */
    var selectItem = function ($item) {
      $tree.jstree('deselect_all');
      if ($item != null)
        $tree.jstree('select_node', $item, true);
    };
    self.currentItem = function ($item) {
      if (arguments.length === 0) {
        if ($currentItem == null)
          $currentItem = self.getItemByValue($input.val());
        return $currentItem;
      }
      else {
        var value = '';
        if ($item.length != 0)
          value = $item.data('value') || '';

        if ($item == $currentItem) {
          changeSuppressed = true;
          $input.val(value).change();
          changeSuppressed = false;
          raise('currentItemChanged', $item);
          return;
        }

        $currentItem = $item;
        changeSuppressed = true;
        $input.val(value);
        selectItem($item);
        $input.change();
        changeSuppressed = false;
        raise('currentItemChanged', $item);
      }
    };
    self.selectedItem = function ($item) {
      if (arguments.length === 0) {
        var jstreeNode = $tree.jstree('get_selected');
        return jstreeNode.length != 0 ? $('#' + jstreeNode, $tree) : $();
      }
      else
        selectItem($item);
    };
    self.getItemByValue = function (value) {
      if (value === undefined)
        return $();
      if (value == '')
        return $('li.tree-empty-node', $tree);
      
      return $('li[data-value="' + value + '"]', $tree); 
    };
    self.selectNone = function () {
      $currentItem = $('li.tree-empty-node', $tree);
      self.selectedItem($currentItem);
    }

    /* item population */
    self.populate = function () {
      var $treeTarget = $('.selectTree-tree', $field);
      if ($flyout)
        $treeTarget = $treeTarget.clone().appendTo($flyout);
      $treeTarget.show();      

      $tree = $treeTarget
        .jstree(
          {
            'core': {
              'animation': false,
              'multiple': false,
              'themes': {
                'dots': false,
                'icons': false
              }
            },
            'search': {
              'search_callback': function (str, node) {
                var trimmedSearchText = unescape(str.toLowerCase().trim());
                if (node.text.toLowerCase().indexOf(trimmedSearchText) >= 0)
                  return true;
                if (node.data.text.toLowerCase().indexOf(trimmedSearchText) >= 0)
                  return true;

                var parentNode = node.parent != '#' ? $tree.jstree('get_node', node.parent) : null;
                if (parentNode) {
                  if (parentNode.text.toLowerCase().indexOf(trimmedSearchText) >= 0)
                    return true;
                  if (parentNode.data.text.toLowerCase().indexOf(trimmedSearchText) >= 0)
                    return true;
                }

                return false;
              },
              'show_only_matches': true
            },
            'plugins': ['search']
          })
        .on('click', 'a', function () {
          var $listItem = $(this).parent();
          var itemValue = $listItem.attr('data-value');
          if (itemValue !== undefined || $listItem.hasClass('tree-empty-node')) {
            self.currentItem($listItem);
          }
          else {
            $tree.jstree('toggle_node', $listItem);
          }
        })
        .on('clear_search.jstree', function () {
          $('.highlight', $tree).closest('a').removeHighlight();
        })
        .on('search.jstree', function (e, args) {
          // these nodes are detached from rendered tree
          var $nodes = args.nodes; 
          var searchtext  = unescape(args.str.toLowerCase().trim());
          var selected = false;
          $nodes.each(function () {
            var id = $(this).attr('id');
            var $n = $('#' + id, $tree);
            $n.find('.jstree-search').highlight(searchtext);
            if (!selected) {
              selected = true;
              self.selectedItem($n);
            }
          });
        })
        .addClass('treeinput');

      $tree.jstree(true).refresh();
    };
    self.clear = function () {
      $currentItem = null;
      $flyout.html('');
    };

    /* selection navigation */
    self.selectNextItem = function () {
      var $current = this.selectedItem();
      var $next;
      if ($current.length == 0 || $current.is(':hidden'))
        $next = $('li:visible', $tree).first();
      else {
        $next = $current.hasClass('jstree-closed') || $current.hasClass('jstree-leaf')
          ? $current.nextAll('li:visible').first()
          : $('li', $current).filter(':visible').first();
        while ($next.length == 0 && $current.length > 0) {
          $current = $current.parentsUntil('.selectTree-tree', 'li').filter(':visible').first();
          $next = $current.nextAll('li:visible').first();
        }
      }
      
      if ($next.length > 0) {
        self.selectedItem($next);
      }
    };
    self.selectPreviousItem = function () {
      var $current = this.selectedItem();
      var $prev;
      if ($current.length == 0 || $current.is(':hidden'))
        $prev = $('li:visible', $tree).first();
      else {
        $prev = $current.prevAll('li:visible').first();
        if ($prev.length == 0)
          $prev = $current.parentsUntil('.selectTree-tree', 'li').filter(':visible').first();
        else {
          while (!$prev.hasClass('jstree-closed') && !$prev.hasClass('jstree-leaf')) {
            $prev = $prev.children('ul').first().children('li:visible').last();
          }
        }
      }

      if ($prev.length > 0) {
        self.selectedItem($prev);
      }
    };

    /* filtering */
    self.filterItems = function (filterText) {
      if (filterText && filterText != '') {
        $tree.jstree('search', escape(filterText));
      }
      else {
        $tree.jstree('clear_search');
        $noneItem = $('li.tree-empty-node', $tree);
        self.selectedItem($noneItem);
        $tree.jstree('open_all');
      }
    };
    self.clearFilter = function () {
      $tree.jstree('clear_search');
      $tree.jstree('close_all');

      var leafs = $tree.jstree('get_bottom_selected', true);
      leafs.forEach(function (item, index) {
        item.parents.forEach(function (parent, parentIndex) {
          $tree.jstree('open_node', parent);
        });
      });
    };
  };

  $.fn.dropdowntree = function () {
    $(this).each(function () {
      var $field = $(this);
      var $mainInput = $field.find('.dropdowntree-realinput');
      var mainInputInitialValue = $mainInput.val();

      // [begin]
      if ($field.data('is-dropdown-up')) return;
      $field.data('is-dropdown-up', true);

      var flyoutAttr = 'dropdowntree-flyout';
      var flyoutIdAttr = 'dropdowntree-flyout-id';
      var flyoutId = '_id_' + Math.random();

      var $textInput = $('.dropdowntree-input', $field)
        .attr(flyoutIdAttr.asData(), flyoutId);
      var $button = $('button', $field).addClass('button button-icon dropdowntree-button')
        .attr('type', 'button')
        .attr('tabindex', -1);
      var $flyout = $('.dropdowntree-flyout', $field)
        .attr(flyoutAttr.asData(), flyoutId)

      var items = new treeItems($, $field, $flyout);

      var setTextInputValue = function (val) {
        return $textInput.val(val).change();
      };

      // move flyout
      $(flyoutAttr.asDataSelector(flyoutId)).remove();
      $flyout.detach(); // flyout rendered server side
      $('body').append($flyout);

      var getInitialText = function () {
        var initialValue = mainInputInitialValue;
        if (initialValue == '')
          return initialValue;

        var $item = items.getItemByValue(initialValue)
        if ($item.length == 0)
          $item = $('.selectTree-tree li[data-value="' + initialValue + '"]', $field);

        return $item.length != 0 ? $item.data('text') : initialValue;
      };

      var $input = $();

      var copyAttributesFromHiddenInputToUserFacingInput = function ($field, $textInput) {
        var $hiddenInput = $('input[type="hidden"]', $field);
        if ($hiddenInput.attr('readonly'))
          $textInput.attr('readonly', $hiddenInput.attr('readonly'));
        if ($hiddenInput.isDisabled())
          $textInput.disable();
        if ($hiddenInput.attr('data-required'))
          $textInput.attr('data-required', $hiddenInput.attr('data-required'));
      }($field, $textInput);

      var populated = false;
      var populateOptions = function () {
        if (populated) return;
        items.populate();
        populated = true;
      };

      var clear = function () {
        items.clear();
        populated = false;
      };

      /* events */
      try {
        $textInput.data('r-is-constructing', true);
        setTextInputValue(getInitialText())
          .click(function () {
            if ($flyout.is(':hidden'))
              open();
            return false;
          })
          .keydown(function (e) { keydown(e); })
          .keyup(function (e) { keyup(e); })
          .blur(function () {
            if (tabKeyPressed) {
              setSelectedItem();
              close();
              tabKeyPressed = false;
            }
          });
      }
      finally {
        $textInput.data('r-is-constructing', false);
      }

      $mainInput.bind('dropdown:reload', function (e, customValue) {
        var lastSelectedValue = items.currentItem() ? items.currentItem().value : null;

        clear();
        populateOptions();

        var itemToReselect = items.getItemByValue(lastSelectedValue);

        if (itemToReselect)
          items.currentItem(itemToReselect);

        update();

        $field.trigger('dropdown:reloaded');
      });

      var documentClick = function (e) {
        var $targetAndParents = $(e.target).parents().add(e.target);
        if ($targetAndParents.index($field) == -1 && $targetAndParents.index($flyout) == -1) {
          setSelectedItem();
          close();
        }
      };
      var updating = false;
      items.on('currentItemChanged', function (item) {
        if (updating) return;
        update();
        close();
      });

      $button.click(function (e) {
        if ($flyout.is(':visible'))
          close();
        else {
          open();
        }
        $textInput.focus();
        return false;
      });

      /* todo: how do we handle these events */
      $mainInput.bind('disabled', function () {
        $textInput.disable();
        $button.disable();
      })
        .bind('enabled', function () {
          $textInput.enable();
          $button.enable();
          $mainInput.enable();
        })
        .focus(function () {
          $textInput.focus();
        });

      /* todo: this could probably be moved into the items but must be careful with order of operations, the bindings
      above must exist before invoking this (or we need to refactor the code) */
      if ($mainInput.is(':disabled')) {
        $mainInput.trigger('disabled');
      }

      /* flyout */
      var positionFlyout = function () {
        var inputOffset = $textInput.offset();
        $flyout.css('left', inputOffset.left);
        $flyout.css('top', inputOffset.top + $textInput.outerHeight());
      };
      var open = function () {
        if ($flyout.is(':visible') || $textInput.isReadonly() || $textInput.isDisabled())
          return false;

        populateOptions();

        positionFlyout();
        if ($flyout.find('li').length > 0)
          $flyout.css('width', $textInput.outerWidth()).show();
        $(document).bind('mouseup', documentClick);

      };
      var close = function () {
        $flyout.hide();
        items.clearFilter();
        $(document).unbind('mouseup', documentClick);
      };
      $(window).resize(function () {
        positionFlyout();
      });
      $mainInput.data("$flyout", $flyout);

      /* keyboard input */
      var tabKeyPressed = false;
      var keys = {
        tab: 9,
        enter: 13,
        shift: 16,
        escape: 27,
        up: 38,
        down: 40,
        s: 83,
        home: 36,
        end: 35
      };
      var keydown = function (e) {
        var key = e.keyCode;
        tabKeyPressed = key == keys.tab;
        enterPressed = key == keys.enter;
        var upPressed = key == keys.up;
        var downPressed = key == keys.down;

        if (tabKeyPressed) {
          return;
        } else if (enterPressed) {
          setSelectedItem();
          close();
        } else if (upPressed) {
          open();
          items.selectPreviousItem();
        } else if (downPressed) {
          open();
          items.selectNextItem();
        }
      };
      var keyup = function (e) {
        var key = e.keyCode;

        if (key == keys.tab || key == keys.enter || key == keys.shift || key == keys.up || key == keys.down || key == keys.home || key == keys.end)
          return;

        if (key == keys.escape) {
          reset();
          close();
          return;
        }

        open();
        items.filterItems($textInput.val());
      };

      /* item selection */
      var getItem = function (value) {
        if (!populated) populateOptions();
        return items.getItemByValue(value);
      };
      $mainInput[0].getItem = getItem;

      var selectItem = function ($item) {
        updating = true;
        items.currentItem($item);
        updating = false;
        update();
      };
      $mainInput[0].selectItem = selectItem;

      var isUpdating = function () {
        return updating;
      };
      $mainInput[0].isUpdating = isUpdating;

      var setSelectedItem = function () {
        var $selectedItem = items.selectedItem();
        if ($selectedItem.length !== 0)
          selectItem($selectedItem);
        else {
          reset();
        }
      };
      var reset = function () {
        items.selectedItem(items.currentItem());
        update();
      };
      var update = function () {
        var $item = items.currentItem();
        if ($item.length != 0) $input.val($item.data('text') || '').change();
        setTextInputValue($item.length != 0 ? ($item.data('text') || '').trim() : $input.val());
      };

      var selectItemByValue = function (itemValue) {
        var $item = getItem(itemValue || '');
        selectItem($item);
      };
      $mainInput[0].selectItemByValue = selectItemByValue;

      $field.data("dropdown", {
        selectItemByValue: selectItemByValue
      });
      // [end]
    });
  }
})(window.Legacy = window.Legacy || {}, jQuery);